import { Grid, useAutocomplete, Tabs, Tab } from "@pankod/refine-mui";
import { useSelect } from "@pankod/refine-core";

import CustomTabPanel from "components/CustomTabPanel";
import useTabs from "hooks/useTabs";

import AutoGeneratedInputCmp from "components/auto-generated-input/AutoGeneratedInputCmp";
//import useSelect from "locales/useSelect"; //my multi-language version of the useSelect hook
import useAuth from "contexts/AuthContext";

export default function CompFields({
  register,
  control,
  errors,
  defaultLanguageRecord,
  getValues,
  setError,
  setValue,
  watch,
  disabled,
}) {
  const [tabValue, handleChange, defProps] = useTabs(0);

  //const owner = JSON.parse(localStorage.getItem("user")).id;
  const auth = useAuth();
  const owner = auth.user?.id ? auth.user?.id : "";
  const { autocompleteProps: facilityAC } = useAutocomplete({
    resource: "strutture",
    pagination: {
      pageSize: 999,
    },
    metaData: {
      fields: ["businessName", "id"],
    },
    filters: [
      {
        field: "owner.id",
        operator: "eq",
        value: owner,
      },
      { field: "gestore", operator: "eq", value: "false" },
    ],
    onSearch: (value) => [
      {
        field: "businessName",
        operator: "contains",
        value,
      },
    ],
  });

  const { autocompleteProps: typeAC } = useAutocomplete({
    resource: "accommodation-types",
    pagination: {
      pageSize: 100,
    },
    metaData: {
      fields: ["id", "name"],
      populate: {
        localizations: {
          fields: ["name", "locale", "id"],
        },
      },
    },
    onSearch: (value) => [
      {
        field: "name",
        operator: "contains",
        value,
      },
    ],
  });

  const { options: servicesAC } = useSelect({
    resource: "accommodation-services",
    pagination: {
      pageSize: 999,
    },
    optionLabel: "name", // -> servicesAC.label
    optionValue: "id", // -> servicesAC.value
    metaData: {
      fields: ["id", "name"],
      populate: {
        localizations: {
          fields: ["name", "locale", "id"],
        },
      },
    },
  });

  const { options: ratePlansOptions } = useSelect({
    resource: "rate-plans",
    pagination: {
      pageSize: 999,
    },
    optionLabel: "name", // -> ratePlansOptions.label
    optionValue: "id", // -> ratePlansOptions.value
    metaData: {
      fields: ["id", "name"],
      populate: {
        localizations: {
          fields: ["name", "locale", "id"],
        },
      },
    },
    filters: [
      {
        field: "owner.id",
        operator: "eq",
        value: owner,
      },
    ],
  });

  const fieldsGeneral = [
    {
      label: "Nome",
      name: "name",
      required: true,
      type: "text",
      localized: true,
    },
    {
      label: "Struttura",
      name: "facility",
      accessor: "businessName",
      options: facilityAC,
      required: true,
      type: "autocomplete",
    },
    {
      label: "Tipologia",
      name: "accommodation_type",
      accessor: "name",
      options: typeAC,
      required: true,
      type: "autocomplete",
    },
    {
      label: "Descrizione",
      name: "description",
      required: true,
      type: "text",
      lines: 4,
      localized: true,
    },
    {
      type: "space",
      height: "2em",
    },
    {
      label: "Quantità",
      name: "quantity",
      required: true,
      type: "number",
      md: 6,
    },
    {
      label: "Dimensione alloggio",
      name: "size",
      required: true,
      type: "number",
      md: 6,
    },
    {
      label: "N minimo occupanti",
      name: "minGuests",
      required: true,
      type: "number",
      md: 4,
    },
    {
      label: "N massimo occupanti",
      name: "maxGuests",
      required: true,
      type: "number",
      md: 4,
    },
    {
      label: "N massimo bambini",
      name: "maxChildren",
      required: true,
      type: "number",
      md: 4,
    },
    // {
    //   label: "Fumatori",
    //   name: "smokersAccepted",
    //   required: true,
    //   type: "switch",
    // },

    // {
    //   type: "divider",
    // },
    // {
    //   type: "title",
    //   variant: "h6",
    //   label: "Configurazione letti",
    // },
    // {
    //   type: "space",
    //   height: "1em",
    // },
    // {
    //   label: "N letti singoli",
    //   name: "singleBeds",
    //   required: true,
    //   type: "number",
    //   md: 4,
    // },
    // {
    //   label: "N letti matrimoniali",
    //   name: "doubleBeds",
    //   required: true,
    //   type: "number",
    //   md: 4,
    // },
    // {
    //   label: "N letti alla francese",
    //   name: "frenchBeds",
    //   required: true,
    //   type: "number",
    //   md: 4,
    // },
    // {
    //   label: "N letti a castello",
    //   name: "bunkBeds",
    //   required: true,
    //   type: "number",
    //   md: 4,
    // },
    // {
    //   label: "N divani letto",
    //   name: "sofaBeds",
    //   required: true,
    //   type: "number",
    //   md: 4,
    // },
    // {
    //   type: "divider",
    // },
    // {
    //   label: "N letti singoli addizionali",
    //   name: "additionalSingleBeds",
    //   required: true,
    //   type: "number",
    //   defaultValue: 0,
    //   md: 4,
    // },
    // {
    //   label: "N letti matrimoniali addizionali",
    //   name: "additionalDoubleBeds",
    //   required: true,
    //   type: "number",
    //   defaultValue: 0,
    //   md: 4,
    // },
    // {
    //   label: "N letti alla francese addizionali",
    //   name: "additionalFrenchBeds",
    //   required: true,
    //   type: "number",
    //   defaultValue: 0,
    //   md: 4,
    // },
    // {
    //   label: "N letti a castello addizionali",
    //   name: "additionalBunkBeds",
    //   required: true,
    //   type: "number",
    //   defaultValue: 0,
    //   md: 4,
    // },
    // {
    //   label: "N divani letto addizionali",
    //   name: "additionalSofaBeds",
    //   required: true,
    //   type: "number",
    //   defaultValue: 0,
    //   md: 4,
    // },
  ];

  const fieldsServices = [
    {
      label: "Servizi",
      name: "accommodation_services",
      required: true,
      type: "multi-select-checkbox",
      options: servicesAC,
    },
  ];

  const fieldsMedia = [
    {
      type: "title",
      variant: "h6",
      label: "Immagine principale",
    },
    {
      label: "Immagine principale",
      name: "image",
      required: true,
      type: "image",
    },
    {
      type: "title",
      variant: "h6",
      label: "Galleria foto",
    },
    {
      label: "Galleria foto",
      name: "gallery",
      required: false,
      type: "gallery",
    },
  ];

  const fieldsRatePlans = [
    {
      label: "Piani tariffari",
      name: "rate_plans",
      required: false,
      type: "multi-select-checkbox",
      options: ratePlansOptions,
    },
  ];

  return (
    <div>
      <Tabs
        value={tabValue}
        onChange={handleChange}
        //aria-label="basic tabs example"
      >
        <Tab label="Informazioni generali" {...defProps(0)} />
        <Tab label="Servizi" {...defProps(1)} />
        <Tab label="Immagini" {...defProps(2)} />
        <Tab label="Piani tariffari" {...defProps(3)} />
      </Tabs>

      <CustomTabPanel value={tabValue} index={0}>
        <Grid container spacing={2}>
          {fieldsGeneral.map((field, index) => {
            return (
              <AutoGeneratedInputCmp
                key={index}
                defaultValue={watch(field.name)}
                {...field}
                register={register}
                control={control}
                errors={errors}
                setError={setError}
                fieldVariants="outlined"
                defaultLanguageRecord={defaultLanguageRecord}
                getValues={getValues}
                setValue={setValue}
                watch={watch}
                disabled={disabled}
              />
            );
          })}
        </Grid>
      </CustomTabPanel>
      <CustomTabPanel value={tabValue} index={1}>
        <Grid container spacing={2}>
          {fieldsServices.map((field, index) => {
            return (
              <AutoGeneratedInputCmp
                key={index}
                defaultValue={watch(field.name)}
                {...field}
                register={register}
                control={control}
                errors={errors}
                setError={setError}
                fieldVariants="outlined"
                defaultLanguageRecord={defaultLanguageRecord}
                getValues={getValues}
                setValue={setValue}
                watch={watch}
                disabled={disabled}
              />
            );
          })}
        </Grid>
      </CustomTabPanel>
      <CustomTabPanel value={tabValue} index={2}>
        <Grid container spacing={2}>
          {fieldsMedia.map((field, index) => {
            return (
              <AutoGeneratedInputCmp
                key={index}
                defaultValue={watch(field.name)}
                {...field}
                register={register}
                control={control}
                errors={errors}
                setError={setError}
                fieldVariants="outlined"
                defaultLanguageRecord={defaultLanguageRecord}
                getValues={getValues}
                setValue={setValue}
                watch={watch}
                disabled={disabled}
              />
            );
          })}
        </Grid>
      </CustomTabPanel>
      <CustomTabPanel value={tabValue} index={3}>
        <Grid container spacing={2}>
          {fieldsRatePlans.map((field, index) => {
            return (
              <AutoGeneratedInputCmp
                key={index}
                defaultValue={watch(field.name)}
                {...field}
                register={register}
                control={control}
                errors={errors}
                setError={setError}
                fieldVariants="outlined"
                defaultLanguageRecord={defaultLanguageRecord}
                getValues={getValues}
                setValue={setValue}
                watch={watch}
                disabled={disabled}
              />
            );
          })}
        </Grid>
      </CustomTabPanel>
    </div>
  );
}
